export default __webpack_public_path__ + "static/media/TER1.9c15d7b8.jpg";